import { useEffect, useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { ModalCore } from "src/Pages/components";

import { FormComprovante } from "./Form/FormComprovante";
import { useResetInputs } from "src/Contexts";
import { TabContext, TabPanel, TabList } from "@mui/lab";

import { Tab } from "@mui/material";

interface IModalComprovante {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  id: string;
}

export const ModalComprovante = ({
  id,
  openModal,
  setOpenModal,
}: IModalComprovante) => {
  const { resetInputs } = useResetInputs();
  const { loadingGravar } = useConfigPageContext();

  const [value, setValue] = useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (!openModal) resetInputs();
  }, [openModal]);

  return (
    <ModalCore
      loadingSubmit={loadingGravar}
      open={openModal}
      setOpen={setOpenModal}
      sxStyle={{ width: "850px" }}
      title="Comprovantes"
    >
      <TabContext value={value}>
        <TabList onChange={handleChange} aria-label="lab API tabs example">
          <Tab
            label="Comprovante de pagamento"
            value="1"
            sx={{ textTransform: "none" }}
          />
          <Tab label="Nota fiscal" value="2" sx={{ textTransform: "none" }} />
        </TabList>

        <TabPanel sx={{ padding: 0 }} value="1">
          <FormComprovante id={id} type="COMPROVANTE_PAGAMENTO" />
        </TabPanel>

        <TabPanel sx={{ padding: 0 }} value="2">
          <FormComprovante id={id} type="NOTA_FISCAL" />
        </TabPanel>
      </TabContext>
    </ModalCore>
  );
};
